import { PeoplesSkeleton } from '../PeopleIFollow';

const PeopleIFollowSkeleton = function PeopleIFollowSkeleton() {
  return (
    <PeoplesSkeleton />
  );
};

export default PeopleIFollowSkeleton;
